module.exports = __webpack_public_path__ + "static/media/img4.68b03f90.png";